import React from "react";
import { Button, Table } from "react-bootstrap";
import { IDocument } from "../../../../interfaces/api/IDocuments";

export default function TableDocument({documentList, handleDocumentUuidRemove} : { documentList: IDocument[] , handleDocumentUuidRemove: (arg0 : string) => void}) {
    return (
        <Table className="table list attachs form-items">
            <thead>
                <tr>
                <th className="name key">Nom</th>
                <th className="description">Description</th>
                <th className="file">Type</th>
                <th className="actions">Actions</th>
                </tr>
            </thead>
            <tbody>
                <TableRows documentList={documentList} handleDocumentUuidRemove={handleDocumentUuidRemove}/>
            </tbody>
        </Table>
    );
}

function TableRows({documentList, handleDocumentUuidRemove} : { documentList: IDocument[], handleDocumentUuidRemove: (arg0 : string) => void})
{
    if(!documentList || documentList.length === 0)
    {
        return (
            <tr>
                <td colSpan={4}>Aucune donnée</td>
            </tr>
        );
    }
    const rows = documentList.map(document =>{
        return(
            <tr key={document.uuid}>
                <td className="name key">{document.name}</td>
                <td className="description">{document.description}</td>
                <td className="type">{document.type}</td>
                <td className="actions">
                    <div className="btns-wrapper">
                        <Button variant="none" size="sm" className="btn-download" title="Télécharger la Pièce jointe">
                            <span className="icon"></span>
                            <span className="text">Télécharger</span>
                        </Button>
                        <Button variant="none" onClick={() => {handleDocumentUuidRemove(document.uuid)}} size="sm" className="btn-delete" data-bs-toggle="modal" data-bs-target="#mediaDeleteConfirmationModal" title="Supprimer cette Pièce jointe">
                            <span className="icon"></span>
                            <span className="text">Supprimer</span>
                        </Button>
                    </div>
                </td>
            </tr>
        );
    }
    );
    return (
        <>
            {rows}
        </>
    );
}